import { Component, ViewChild, AfterViewInit } from '@angular/core';

import * as _ from 'lodash';
import { Subscription } from 'rxjs';

import { BaseComponent } from '../_base.component';

import { InputFileCropImageModal } from './crop-image.modal';
import { InputFileTakePictureModal } from './take-picture.modal';

import { DialogBaseService } from '../../../../dialog/dialog.base.service';
import { ButtonComponent } from '../../../../button';

/**
 * @ignore
 */
@Component({
  selector: 'uex-input-file',
  templateUrl: './file.component.html',
  host: {
    class: 'uex-input-file'
  }
})
export class InputFileComponent extends BaseComponent<string> implements AfterViewInit {
  @ViewChild('fileButton', { static: false }) private _fileButton: ButtonComponent;
  @ViewChild('pictureButton', { static: false }) private _pictureButton: ButtonComponent;
  @ViewChild('clearButton', { static: false }) private _clearButton: ButtonComponent;

  constructor(
    private _dialogBaseService: DialogBaseService
  ) { super(); }

  public ngAfterViewInit() {
    this.setNativeElement();
    this.onInit(this);
  }

  public focus() {
    if (this._clearButton) {
      this._clearButton.elementRef.nativeElement.focus();

    } else if (this._fileButton) {
      this._fileButton.elementRef.nativeElement.focus();

    } else if (this._pictureButton) {
      this._pictureButton.elementRef.nativeElement.focus();
    }
  }

  public isImage(value: string = this.value): boolean {
    return value && (value.indexOf('image/jpg') > -1 || value.indexOf('image/jpeg') > -1 || value.indexOf('image/png') > -1 || /^https\:\/\/graph\.facebook\.com\/(.+)$/.test(value) || /^(http\:\/\/|https\:\/\/)(.+)(\.jpg|\.jpeg|\.png)$/.test(value));
  }

  public allowImage(): boolean {
    if (this.schema.validations.fileType) {
      if (_.isString(this.schema.validations.fileType)) {
        const rule = this.schema.validations.fileType;
        const requiredFileTypes: Array<string> | string = _.isFunction(rule) ? (<any>rule)() : rule;
        const required_types_array: Array<string> = _.isString(requiredFileTypes) ? requiredFileTypes.toString().split(',') : (_.isArray(requiredFileTypes) ? (<any>requiredFileTypes) : null);
        if (required_types_array.indexOf('image') > -1 || required_types_array.indexOf('png') > -1 || required_types_array.indexOf('jpeg') > -1 || required_types_array.indexOf('jpg') > -1) {
          return true;
        }
      }
    }
    return true;
  }

  public inputClick(event: MouseEvent) {
    event.preventDefault();
    this.elementRef.nativeElement.click();
  }

  public onFileChange(file_input: any) {
    this.clear();
    if (file_input.target.files && file_input.target.files[0]) {
      const reader = new FileReader();
      reader.onload = (event: any) => {
        const value = event.target.result;
        this.value = value;
        if (this.isImage()) { this._cropImage(); }
      };
      reader.readAsDataURL(file_input.target.files[0]);
    }
  }

  public takePicture() {
    const modal = this._dialogBaseService.open(InputFileTakePictureModal, null, {
      size: 'sm',
      header: {
        title: 'Tirar foto',
        closable: true
      }
    });
    const value_subscription: Subscription = modal.onReturnValue.subscribe((value) => {
      value_subscription.unsubscribe();
      this.value = value;
      if (this.isImage()) { this._cropImage(); }
    });
    modal.onClose.then(() => this.schema.validate());
  }

  public clearFile() {
    this.clear();
    this.schema.validate();
  }

  private _cropImage() {
    let format: string;
    let allowNotCropAction = this.schema.allowNotCropAction;
    let cropBoxResizable = this.schema.cropBoxResizable;
    let aspectRatio = this.schema.aspectRatio == undefined ? { width: 1, height: 1} : this.schema.aspectRatio;

    let minWidth = this.schema.minWidth || 0;
    let minHeight = this.schema.minHeight || 0;
    let zoomable = this.schema.zoomable == undefined ? true : this.schema.zoomable;

    if (this.schema.invalid) { return; }

    if (this.value.indexOf('image/jpeg') > -1 || this.value.indexOf('image/jpg') > -1) {
      format = 'image/jpeg';
    } else if (this.value.indexOf('image/png') > -1) {
      format = 'image/png';
    }
    if (!format) { return; }

    const modal = this._dialogBaseService.open(InputFileCropImageModal, {
      image: this.value,
      format: format,
      allowNotCropAction: allowNotCropAction,
      cropBoxResizable : cropBoxResizable,
      aspectRatio : aspectRatio.width / aspectRatio.height,
      zoomable: zoomable,
      minWidth: minWidth,  
      minHeight: minHeight, 
    }, {
      size: 'lg',
      header: {
        title: 'Cortar imagem',
        closable: allowNotCropAction
      }
    });
    const value_subscription: Subscription = modal.onReturnValue.subscribe((value) => {
      value_subscription.unsubscribe();
      this.value = value;
    });
    modal.onClose.then(() => this.schema.validate());
  }
}
